var finn = {
  home_page: function(){
    $('.hmtt_slider').slick({
      dots: true,
      arrows: false,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      adaptiveHeight: true
    });

     $('.hiwp_slider').slick({
        dots: false,
        arrows: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1 
    });
    
    $('body').on('change', '.hiwpdvt_flx input[type="radio"]', function(){
        var id = $(this).data('variant_id');
        console.log(id);
        $(this).closest('.hiwpd_detail')
                .find('product-form [name="id"], form.product-form [name="id"]')
                .val(id)
                .trigger('change');
    });

    
  },
  faq: function(){
      $('.fqct_question').on('click', function(){
          $(this).toggleClass('active');
          $(this).next('.fqct_answer').slideToggle();
      });

      $('.fqli').on('click', function(){
          var id = $(this).data('id');
          var top =  $(".fqct_heading[data-id='"+id+"']").offset().top - 70;
          $('html,body').animate({
              scrollTop: top
            }, 'slow');
          });
       
  },
  all_option: function(){
    $('body').on('click', '.dsptb_li', function(){
        $('.dsptb_li, .dsptb_item ').removeClass('active');

        $(this).addClass('active');
        var id = $(this).data('id');
        $('.dsptb_item[data-id="'+id+'"]').addClass('active');
    });

      $('body').on('click', '.pdtsz_close, .pdtsz_bg', function(){
          $('.pdtsz_popup').removeClass('active');
      });

      $('body').on('click', '.pdtsz_size', function(){
          $('.pdtsz_popup').addClass('active');
      });
 
      $('body').on('click', '.vmc_txt', function(){
          $('.clpp_box').addClass('active');
      });

      $('body').on('click', '.clpp_bg, .clpp_close', function(){
          $('.clpp_box').removeClass('active');
      });

      $('body').on('click', '.btn-view-product, .btn-view-collection', function(){
          var href = $(this).attr('href'); 
          window.location.href = href;
      });
  },
  view_collection: function(){
      $('.grdvw_img').on('click', function(){
          $('.grdvw_img').removeClass('active');
          $(this).addClass('active');
          var cl = $(this).data('class');
          $('#product-grid').removeClass('grid--2-col-desktop')
                            .removeClass('grid--1-col-tablet-down')
                            .removeClass('grid--2-col-tablet-down')
                            .removeClass('grid--3-col-tablet-down')
                            .removeClass('grid--4-col-desktop')
                            .removeClass('grid--6-col-desktop')
                            .removeClass('grid_8');
          $('#product-grid').addClass(cl);
      });

      $('.hide_view_filter').on('click', function(){
          $(this).toggleClass('active');
          var html = $(this).html();
          var n_html = $(this).attr('data-text');

          $(this).html(n_html).attr('data-text', html);
          $('.facets-wrapper').toggleClass('active');

          setTimeout(function(){
              $('.facets-wrapper').toggleClass('hv_hidden'); 
          }, 600); 

      }); 
  },
  top_header: function(){
      setInterval(function(){
        var tmbn = $('#fsb_container').text();
        if(tmbn != ''){
          $('body').addClass('big_space');
        }else{
          $('body').removeClass('big_space');
        }
      }, 1500); 
  }
}
$(function(){
  finn.home_page();
  finn.faq();
  finn.all_option();
  finn.view_collection();
  finn.top_header();
});

$(window).on('scroll', function () {
    if ($(window).scrollTop() > 100){
        $('body').addClass('top_zero');
    } else {
        $('body').removeClass('top_zero');
    }
});

 

$(function(){
  // slick init
  var full_slider = $('.hfws_slider');
  /*full_slider.slick({
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true,
    dots: true,
    appendDots: $('.hfwsnv_dots'),
    customPaging: function(slider, i) {
      return '<button class="dot"></button>';
    }
  });*/



  $('.hfwsnv_priv').on('click', function() {
    full_slider.slick('slickPrev');
  });
  $('.hfwsnv_next').on('click', function() {
    full_slider.slick('slickNext');
  });

  // set zoom background from image
  /*$('.image-wrapper').each(function(){
    const $img = $(this).find('img');
    const $lens = $(this).find('.zoom-lens');
    const src = $img.attr('src');
    $lens.css('background-image', `url(${src})`);
  });

  // zoom follow scroll (parallax)
  $(window).on('scroll resize', function(){
    $('.slider-section').each(function(){
      const sectionTop = $(this).offset().top;
      const sectionHeight = $(this).outerHeight();
      const scrollTop = $(window).scrollTop();
      const windowHeight = $(window).height();
 
      if (scrollTop + windowHeight > sectionTop && scrollTop < sectionTop + sectionHeight) {
        const progress = (scrollTop + windowHeight/2 - sectionTop) / sectionHeight;
        const move = (progress - 0.5) * 80; // scroll effect range
        const $active = $(this).find('.slick-active .fixed-zoom-box');
        $active.css('transform', `translate(-50%, calc(-50% + ${move}px))`);
      }
    });
  });

  // animate zoom lens background position (parallax illusion)
  $(window).on('scroll', function(){
    $('.slider-section').each(function(){
      const sectionTop = $(this).offset().top;
      const sectionHeight = $(this).outerHeight();
      const scrollTop = $(window).scrollTop();
      const windowHeight = $(window).height();
      if (scrollTop + windowHeight > sectionTop && scrollTop < sectionTop + sectionHeight) {
        const scrollPercent = (scrollTop - sectionTop) / sectionHeight;
        const bgPosY = 50 + scrollPercent * 20; // subtle movement
        const $lens = $(this).find('.slick-active .zoom-lens');
        $lens.css('background-position', `center ${bgPosY}%`);
      }
    });  
  });*/

  //$(window).trigger('scroll');
});